import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { io } from 'socket.io-client';
import { generateId } from '@appblocks/utils';

/**
 * {
 * message: string,
 * id: string,
 * progress: number | undefined,
 * title: string | undefined,
 * timeout: number
 * cancellable: boolean,
 * }
 */

export const messagesSlice = createSlice({
    name: 'messages',
    initialState: {
        messages: [],
        loadingMessage: '',
    },
    reducers: {
        addMessage: (state, action) => {
            const newState = {
                ...state,
                messages: [
                    ...state.messages,
                    action.payload,
                ],
            };
            return newState;
        },
        clearMessages: (state, action) => {
            state.messages = [];
        },
        removeMessage: (state, action) => {
            const messages = state.messages;
            for (let i = 0; i < messages.length; i++) {
                if (messages[i].id === action.payload) {
                    messages.splice(i, 1);
                }
            }
            state.messages = [...messages];
        },
        updateMessage: (state, action) => {
            const messages = state.messages;
            for (let i = 0; i < messages.length; i++) {
                if (messages[i].id === action.payload.id) {
                    messages[i] = {
                        ...messages[i],
                        ...action.payload.message,
                    };
                    break;
                }
            }
            state.messages = [...messages];
        },
        setLoadingMessage: (state, action) => {
            const newState = {
                ...state,
                loadingMessage: action.payload,
            };
            return newState;
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    addMessage,
    clearMessages,
    updateMessage,
    removeMessage,
    setLoadingMessage,
} = messagesSlice.actions;

export default messagesSlice.reducer;

export const messagesMiddleware = store => next => (action) => {
    if (action.payload && action.type === 'messages/addMessage') {
        const id = action.payload.id || generateId();

        const newAction = {
            ...action,
            payload: {
                ...action.payload,
                id,
            },
        };

        return next(newAction);
    }
    return next(action);
};
